// extracted by mini-css-extract-plugin
module.exports = {"root":"Newsletter_root__3QKLl","titleWrapper":"Newsletter_titleWrapper__agYqq","title":"Newsletter_title__3vmiB","form":"Newsletter_form__1ALUk"};